import React from 'react';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { BodyText, BoldBodyText, Notification } from '../../ui-toolkit/components';
import { useHasPermissions } from 'components/accessControl/hooks/useHasPermissions';

interface IPermissionNotificationProps {
  allowedPermissions: ePermissions[];
  requireAll?: boolean;
}

export const PermissionNotification: React.FC<IPermissionNotificationProps> = ({ allowedPermissions, requireAll }) => {
  const isAuthorized = useHasPermissions(allowedPermissions, requireAll);
  return (
    <>
      {!isAuthorized ? (
        <Notification type={'error'}>
          <BoldBodyText>You have read-only access to this page.</BoldBodyText>
          <BodyText>If you feel like this is in error please contact your manager.</BodyText>
        </Notification>
      ) : null}
    </>
  );
};
